import { useTranslations } from 'next-intl'

import classnames from 'classnames'
import classNames from 'classnames'
import { format } from 'date-fns'

import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Image from '~/components/atoms/Image/Image'
import SpecificImage from '~/components/atoms/SpecificImage/SpecificImage'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import firstLettersConcatenated from '~/utils/firstLetterConcatenated'

import styles from './ArticleFooterAuthor.module.css'

export interface ArticleFooterAuthorProps {
  author: {
    name: string
    slug: string
    image: any
    bio?: string
    bioFallback?: any
  }
  reviewedBy?: {
    name: string
    slug: string
    image: any
  }
  clickEvent?: any
  centered?: boolean
  showDefault?: boolean
  authorPretext?: string
  publishDate?: string
  updatedAt?: string
}

export default function ArticleFooterAuthor({
  author,
  reviewedBy,
  clickEvent,
  centered = true,
  showDefault = true,
  authorPretext,
  publishDate,
  updatedAt,
}: ArticleFooterAuthorProps) {
  const t = useTranslations('common')
  const tArticle = useTranslations('articlePage')
  const authorsName = author?.name ? author.name : 'Erin Argun'
  const reviewedByname = reviewedBy?.name
    ? reviewedBy.name
    : 'Charlotte Stewart'

  if (!showDefault && !author?.name) return null

  return (
    <div className={styles.base}>
      <div className={styles.avatars}>
        <div className={styles.firstAvatar}>
          <div className={classnames(styles.avatar)}>
            {!author && (
              <Image asset="https:cdn.sanity.io/images/dqllnil6/production/60496f739545b9cdc6d070b592b1162f675c5c59-1575x1912.png?w=64&q=60&auto=format" />
            )}
            {author?.image?.asset ? (
              <SpecificImage
                asset={author.image.asset}
                alt={author.name}
                width={60}
              />
            ) : (
              <div className={styles.intialsFallback}>
                <Text size={TextSizes.secondaryTitleMicro}>
                  {firstLettersConcatenated(authorsName)}
                </Text>
              </div>
            )}
          </div>
        </div>
        {reviewedBy?.name && (
          <div className={classnames(styles.secondAvatar)}>
            <div className={classnames(styles.avatar)}>
              {!reviewedBy && (
                <Image asset="https:cdn.sanity.io/images/dqllnil6/production/60496f739545b9cdc6d070b592b1162f675c5c59-1575x1912.png?w=64&q=60&auto=format" />
              )}
              {reviewedBy?.image?.asset ? (
                <SpecificImage
                  asset={reviewedBy.image.asset}
                  alt={reviewedBy.name}
                  width={60}
                />
              ) : (
                <div className={styles.intialsFallback}>
                  <Text size={TextSizes.secondaryTitleMicro}>
                    {firstLettersConcatenated(reviewedByname)}
                  </Text>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {author?.bio && (
        <Text size={TextSizes.bodySml} className={styles.bio}>
          {author.bio}
        </Text>
      )}
      {!author?.bio && author?.bioFallback && (
        <div className={styles.bio}>
          <BlockContent value={author.bioFallback} size={TextSizes.bodySml} />
        </div>
      )}

      <div className={styles.publicationInfo}>
        {updatedAt && (
          <div className={classNames(styles.publicationInfoItem)}>
            <Text
              size={TextSizes.magSecondaryBodySml}
              className={styles.publicationInfoItemTitle}
            >
              {tArticle('lastUpdated')}
            </Text>
            <Text
              size={TextSizes.magSecondaryBodySml}
              className={styles.publicationInfoItemValue}
            >
              {format(new Date(updatedAt), 'd MMM yyyy')}
            </Text>
          </div>
        )}
      </div>
    </div>
  )
}
